import { setTableButtons } from '@/utils/getbuttons.js'
const concealedWork = {
  concealedWork: {
    name: 'concealedWork',
    componentTypes: ['navigate', 'check', 'tables', 'dialogForm'],
    queryFun: 'concealedWork/getConcealedWorkList',
    getListFun: 'concealedWork/getConcealedWorkList',
    addFun: 'concealedWork/addConcealedWork',
    editFun: 'concealedWork/editConcealedWork',
    deleteFun: 'concealedWork/deleteConcealedWork',
    detailPage: [
      {
        buttonName: '验收图片',
        type: 'preview',
        name: 'concealedWork'
      },
      {
        buttonName: '验收视频',
        type: 'dialogForm',
        name: 'concealedWork',
        checkType: 'useRowData',
        pageStatus: 'check'
      },
      {
        buttonName: '验收',
        type: 'dialogForm',
        name: 'concealedWork',
        checkType: 'useRowData',
        pageStatus: 'edit'
      }
    ],
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      subitemUid: '',
      isCompleted: ''
    },
    selectData: [
      {
        key: 'orgUid',
        label: '项目标段名称',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true,
        span: 8
      },
      {
        key: 'subitemUid',
        label: '分部分项名称',
        type: 'cascader',
        wide: true,
        options: (params) => {
          return params.getters['division/progressSubitem']
        },
        placeholder: '请在关联有进度分项的分部分项中选择',
        filterable: true,
        showAllLevels: false,
        checkByValue: true,
        emitPath: false,
        span: 8
      },
      {
        key: 'isCompleted',
        label: '完成状态',
        type: 'select',
        options: [
          { label: '待验收', value: '待验收' },
          { label: '已验收', value: '已验收' },
          { label: '未完成', value: '未完成' }
        ],
        span: 8
      }
    ],
    outListHeight: 200,
    rowData: (params) => {
      return params.state.concealedWork.concealedWorkList
    },
    expandAll: true,
    columns: [
      {
        prop: 'label',
        label: '\xa0\xa0\xa0隐蔽工程分项编码及名称',
        align: 'left',
        width: '500px',
        overflowWidth: '80px'
      },
      {
        prop: 'concealedWork',
        label: '隐蔽工程类型',
        tooltip: () => {
          return (row) => {
            return { tipValue: row.acceptanceContents }
          }
        }
      },
      {
        prop: 'workFinishFlag',
        label: '作业完成指标(%)'
      },
      {
        prop: 'isCompleted',
        label: '完成状态',
        tag: [
          { label: '待验收', type: 'warning' },
          { label: '已验收', type: 'success' }
        ],
        tooltip: () => {
          return (row) => {
            const rate = row.rateOfProgress || row.rateOfProgress === 0 ? row.rateOfProgress : 0
            return { tipValue: '当前形象进度完成 ' + rate + '%' }
          }
        }
      },
      {
        prop: 'checkImagesInfo',
        label: '验收图片',
        drillDown: true
      },
      {
        prop: 'checkVideosInfo',
        label: '验收视频',
        drillDown: true
      },
      {
        label: '操作',
        buttons: () => {
          return (row) => {
            return !row.children ? setTableButtons(['验收']) : null
          }
        }
      }
    ],
    concealedWork: {
      name: 'concealedWork',
      title: (params) => {
        return params.pageStatus === 'check'
          ? '查看验收图片和视频'
          : '验收隐蔽工程'
      },
      editFun: 'concealedWork/editConcealedWork',
      getParentFun: 'concealedWork/getConcealedWorkList',
      manualUpload: true,
      formParams: {
        uid: '',
        checkImages: [],
        checkVideos: [],
        fileLists: {
          checkImages: [],
          checkVideos: []
        }
      },
      formRules: {
        checkImages: [
          {
            required: (params) => {
              return (
                params.formValues &&
                params.formValues.fileLists &&
                (!params.formValues.fileLists.checkVideos ||
                  !params.formValues.fileLists.checkVideos.length)
              )
            },
            message: '验收视频为空时至少上传1张,最多4张',
            trigger: 'blur',
            type: 'array'
          }
        ],
        checkVideos: [
          {
            required: (params) => {
              return (
                params.formValues &&
                params.formValues.fileLists &&
                (!params.formValues.fileLists.checkImages ||
                  !params.formValues.fileLists.checkImages.length)
              )
            },
            message: '验收图片为空时至少上传1个，最多4个',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'checkMediaTip',
          type: 'tag',
          tag: '验收图片和验收视频都最多4个，不可同时为空。拍摄和相册选择的验收视频均不超过1分钟。上传后点确定才保存；删除先移出队列，点确定后才删除数据和文件。',
          span: 24
        },
        {
          key: 'checkImages',
          label: '验收图片',
          type: 'upload',
          autoUpload: false,
          limit: 4,
          span: 24
        },
        {
          key: 'checkVideos',
          label: '验收视频',
          type: 'upload',
          url: '#',
          listType: 'text',
          fileType: 'video',
          showFilelist: false,
          autoUpload: false,
          limit: 4,
          span: 24
        }
      ]
    }
  }
}

export default concealedWork
